<div class="w-full bg-white border border-[#f2f2f2] shadow-(--my-shadow2) rounded-[5px]">
    <div class="flex items-center justify-between border-b border-[#d9d9d9]">
        <p class="text-sm sm:text-sm lg:text-base text-[#444] font-medium capitalize ps-2">Order History Report</p>
        <div class="w-1/2 flex justify-start items-center">
            <button (click)="setActiveTab('week')" [ngClass]="{
          'bg-white text-[#444] font-medium outline-0 border-b-2 border-[#c19725]': activeTab === 'week',
          'text-[#898989]': activeTab !== 'week'
        }" class="flex-1 px-2 sm:px-4 py-2 rounded-tl-[4px] flex justify-center items-center text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
                Week
            </button>
            <button (click)="setActiveTab('month')" [ngClass]="{
          'bg-white text-[#444] font-medium outline-0 border-b-2 border-[#c19725]': activeTab === 'month',
          'text-[#898989]': activeTab !== 'month'
        }" class="flex-1 px-2 sm:px-4 py-2 rounded-tl-[4px] flex justify-center items-center text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
                Month
            </button>
            <button (click)="setActiveTab('year')" [ngClass]="{
          'bg-white text-[#444] font-medium outline-0 border-b-2 border-[#c19725]': activeTab === 'year',
          'text-[#898989]': activeTab !== 'year'
        }" class="flex-1 px-2 sm:px-4 py-2 rounded-tr-[4px] flex justify-center items-center text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
                Year
            </button>
        </div>
    </div>

    <div *ngIf="activeTab === 'week'">
        <div class="px-4 py-4">
            <div class="flex items-center justify-between ">
                <div class="ms-auto flex justify-end items-center">
                    <svg class="cursor-pointer" (click)="navigate('prev')" width="8" height="12" viewBox="0 0 8 12" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.4 6L8 10.6L6.6 12L0.6 6L6.6 0L8 1.4L3.4 6Z" fill="#C19725" />
                    </svg>
                    <span class="capitalize text-sm md:text-base text-444 font-medium px-1 sm:px-3">{{ activeDateLabel }}</span>
                    <svg class="cursor-pointer" (click)="navigate('next')" width="8" height="12" viewBox="0 0 8 12" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.6 6L0 1.4L1.4 0L7.4 6L1.4 12L0 10.6L4.6 6Z" fill="#C19725" />
                    </svg>
                </div>
            </div>
            <div class="w-3/4 mx-auto">
                <canvas #weekCanvas></canvas>
            </div>
        </div>
    </div>

    <div *ngIf="activeTab === 'month'">
        <div class="px-4 py-4">
            <div class="flex items-center justify-between ">
                <div class="ms-auto flex justify-end items-center">
                    <svg class="cursor-pointer" (click)="navigate('prev')" width="8" height="12" viewBox="0 0 8 12" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.4 6L8 10.6L6.6 12L0.6 6L6.6 0L8 1.4L3.4 6Z" fill="#C19725" />
                    </svg>
                    <span class="capitalize text-sm md:text-base text-444 font-medium px-1 sm:px-3">{{ activeDateLabel }}</span>
                    <svg class="cursor-pointer" (click)="navigate('next')" width="8" height="12" viewBox="0 0 8 12" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.6 6L0 1.4L1.4 0L7.4 6L1.4 12L0 10.6L4.6 6Z" fill="#C19725" />
                    </svg>
                </div>
            </div>
            <div class="w-3/4 mx-auto">
                <canvas #monthCanvas></canvas>
            </div>
        </div>
    </div>

    <div *ngIf="activeTab === 'year'">
        <div class="px-4 py-4">
            <div class="flex items-center justify-between ">
                <div class="ms-auto flex justify-end items-center">
                    <svg class="cursor-pointer" (click)="navigate('prev')" width="8" height="12" viewBox="0 0 8 12" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.4 6L8 10.6L6.6 12L0.6 6L6.6 0L8 1.4L3.4 6Z" fill="#C19725" />
                    </svg>
                    <span class="capitalize text-sm md:text-base text-444 font-medium px-1 sm:px-3">{{ activeDateLabel }}</span>
                    <svg class="cursor-pointer" (click)="navigate('next')" width="8" height="12" viewBox="0 0 8 12" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.6 6L0 1.4L1.4 0L7.4 6L1.4 12L0 10.6L4.6 6Z" fill="#C19725" />
                    </svg>
                </div>
            </div>
            <div class="w-3/4 mx-auto">
                <canvas #yearCanvas></canvas>
            </div>
        </div>
    </div>
</div>
